"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEventForDay = void 0;
var _dates = require("../../utils/dates");
const getEventForDay = (events, day) => {
  const res = [];
  for (let event of events) {
    if ((0, _dates.datesAreOnSameDay)(event.date, day)) res.push(event);
  }
  return res;
};
exports.getEventForDay = getEventForDay;